import Home from '../views/Home.vue'
import dashboardClientes from './dashboardClientes.js'

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Iniciar sesión'
    }
  },
  {
    path: '/recuperar-contrasena',
    name: 'recuperar-contrasena',
    component: () => import('@/components/RecoveryPassword.vue'),
    meta: {
      title: 'Recuperar contraseña'
    }
  },
  {
    path: '/restablecer-contrasena/:hash',
    name: 'restablecer-contrasena',
    component: () => import('@/components/ResetPassword.vue'),
    meta: {
      title: 'Restablecer contraseña'
    }
  },
  {
    path: '/definir-contrasena',
    name: 'definir-contrasena',
    component: () => import('@/components/ForceResetPassword.vue'),
    meta: {
      title: 'Restablecer contraseña'
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/layouts/Clientes.vue'),
    meta: {
      title: 'Mi portal'
    },
    children: dashboardClientes
  }
];